export default function getExtraDuration(item) {
  const durationInSeconds = item?.end_at?.timestamp - item?.start_at?.timestamp;
  if (durationInSeconds > 86400) {
    return '';
  }
  return durationInSeconds / 60 + ' min.';
}
